const ONE_MB = 1048000;
const DEFAULT_SCALE = 1;

export const checkImageSizeIsLessThanLimit = (file) => {
  return file.size < ONE_MB;
};

/**
 * @param {File} file - The source image
 * @param {number} aspectRatio - The aspect ratio
 * @return {Promise<File>} A Promise that resolves with the resulting image as a file element
 */

export const cropImageWithAspectRatio = (file, aspectRatio) => {
  return new Promise((resolve) => {
    const url = window.URL || window.webkitURL;
    const objectUrl = url.createObjectURL(file);

    const inputImage = new Image();
    let newFile;
    let imageIsReady = false;
    let scale = DEFAULT_SCALE;

    inputImage.onload = () => {
      const inputWidth = inputImage.naturalWidth;
      const inputHeight = inputImage.naturalHeight;

      const inputImageAspectRatio = inputWidth / inputHeight;
      let outputWidth = inputWidth;
      let outputHeight = inputHeight;
      let outputX = 0;
      let outputY = 0;

      if (inputImageAspectRatio > aspectRatio) {
        outputWidth = inputHeight * aspectRatio;
      } else if (inputImageAspectRatio < aspectRatio) {
        outputHeight = inputWidth / aspectRatio;
      }
      // create a canvas that will present the output image
      const outputImage = document.createElement('canvas');

      while (!imageIsReady) {
        outputImage.width = parseInt(outputWidth * scale);
        outputImage.height = parseInt(outputHeight * scale);
        outputY = (inputHeight - outputImage.height) * 0.5;
        outputX = (inputWidth - outputImage.width) * 0.5;
        const ctx = outputImage.getContext('2d');
        ctx.drawImage(inputImage, outputX, outputY, outputWidth, outputHeight, 0, 0, outputWidth, outputHeight);
        newFile = canvasToFile(outputImage, file.name, file.type);
        imageIsReady = (newFile.size / ONE_MB) < 1;
        scale *= 0.7;
      }
      resolve(newFile);
    };

    // start loading our image
    inputImage.src = objectUrl;
  });
};

const canvasToFile = (outputImage, fileName, fileType) => {
  const img = outputImage.toDataURL();
  const blob = imageURItoBlob(img);
  return new File([blob], fileName, { type: fileType });
};

const imageURItoBlob = (dataURI) => {
  let byteString;
  if (dataURI.split(',')[0].indexOf('base64') >= 0)
    byteString = atob(dataURI.split(',')[1]);
  else
    byteString = unescape(dataURI.split(',')[1]);
  const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
  const ia = new Uint8Array(byteString.length);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ia], { type: mimeString });
};
